import * as React from "react";
import {
    Chart, ChartSeries, ChartSeriesItem, ChartCategoryAxis, ChartCategoryAxisItem, ChartValueAxis,
    ChartValueAxisItem, ChartTitle, ChartLegend,exportVisual } from "@progress/kendo-react-charts";
import configData from "../../config.json";
import { GetSession, GetToken } from "../../components/Session";
import { DateRangePicker } from "@progress/kendo-react-dateinputs";
import { Splitter } from "@progress/kendo-react-layout";
import { Button } from "@progress/kendo-react-buttons";
import {  MultiSelect } from "@progress/kendo-react-dropdowns";
import "hammerjs";
import { param } from "jquery";
import { exportPDF } from "@progress/kendo-drawing";
import { saveAs } from "@progress/kendo-file-saver";
import { GetCloudLogin } from "../../WeighBridge/Helpers";
import { filterBy } from "@progress/kendo-data-query";

const PerformanceTrend = () => {
  const [panes, setPanes] = React.useState([{ size: "15%", collapsible: true}, {}]);
  const onChange = (event) => {setPanes(event.newState);};
  const [categories, setCategories] = React.useState(null);
  const [sales, setSales] = React.useState(null);
  const [productPerformance, setProductPerformance] = React.useState(null);
  const [pieData, setPieData ] = React.useState(null);
  const [accumulated, setAccumulated] = React.useState(null);
  const [siteHeading, setSiteHeading ] = React.useState("Site Performance");
  const [loadTypes, setLoadTypes] = React.useState([]);
  const [loadType, setLoadType] = React.useState(JSON.parse(localStorage.getItem('DashboardLoadTypes')));
  const [loadTypeData, setloadTypeData] = React.useState([]);
  const [vehicleTypes, setVehicleTypes] = React.useState([]);
  const [vehicleType, setVehicleType] = React.useState(JSON.parse(localStorage.getItem('DashboardVehicleTypes')));
  const [vehicledata, setvehicleData] = React.useState([]);
  const [jobs, setJobs] = React.useState([]);
  const [job, setJob] = React.useState(JSON.parse(localStorage.getItem('DashboardJobs')));
  const [jobdata, setjobData] = React.useState([]);
  const [customers, setCustomers] = React.useState([]);
  const [customer, setCustomer] = React.useState(JSON.parse(localStorage.getItem('DashboardCustomers')));
  const [customerdata, setcustomerData] = React.useState([]);
  const [sources, setSources] = React.useState([]);
  const [source, setSource] = React.useState(JSON.parse(localStorage.getItem('DashboardSources')));
  const [sourcedata, setsourceData] = React.useState([]);
  const [destinations, setDestinations] = React.useState([]);
  const [destination, setDestination] = React.useState(JSON.parse(localStorage.getItem('DashboardDestinations')));
  const [destinationdata, setdestinationData] = React.useState([]);
  const [sites, setSites] = React.useState([]);
  const [site, setSite] = React.useState(JSON.parse(localStorage.getItem('DashboardSites')));
  const [sitedata, setsiteData] = React.useState([]);
  const [products, setProducts] = React.useState([]);
  const [product, setProduct] = React.useState(JSON.parse(localStorage.getItem('DashboardProducts')));
  const [productdata, setproductData] = React.useState([]);
  const [directions, setDirections] = React.useState([]);
  const [direction, setDirection] = React.useState(JSON.parse(localStorage.getItem('DashboardDirections')));
  const [labels, setLabels] = React.useState(["1", "2"]);
  const [title, setTitle] = React.useState("");
  const [salesYAxis, setSalesYAxis] = React.useState("");
  const [productYAxis, setProductYAxis] = React.useState("");
  const [accYAxis, setAccYAxis] = React.useState("");
  const sale = React.useRef(null);
  const productgraph = React.useRef(null);
  const total = React.useRef(null);
  const sitegraph = React.useRef(null);

  const onImageExportClick = (e) => {
    var chart = e.currentTarget.name;
    var chartVisual = null;
    if(chart == 'sales'){
       chartVisual = sale.current && exportVisual(sale.current);
    }
    else if(chart == 'product'){
       chartVisual = productgraph.current && exportVisual(productgraph.current);
    }
    else if(chart == 'total'){
       chartVisual = total.current && exportVisual(total.current);
    }
    else{
       chartVisual = sitegraph.current && exportVisual(sitegraph.current);
    }
    
    if (chartVisual) {
      exportPDF(chartVisual, {
        paperSize: "A4",
        landscape: true,
      }).then((dataURI) => saveAs(dataURI, "Weekly Performance.pdf"));
    }
  };

  let dr = JSON.parse(localStorage.getItem('DashboardDates'));
  if (dr !== null){
      if (dr.start !== null) dr.start = new Date(dr.start);
      if (dr.end !== null) dr.end = new Date(dr.end);
  } else {
    dr = { start: null, end: null};
  }
  const [dateRange, setDateRange] = React.useState(dr);

  const rangeChanged = (event) => { 
    let dr = event.target.value;
    setDateRange(dr); 
    localStorage.setItem("DashboardDates", JSON.stringify(dr));
  }
  const loadTypeChanged = (event) => {
    setLoadType(event.target.value);
    localStorage.setItem("DashboardLoadTypes", JSON.stringify(event.target.value));
  };
  const vehicleTypeChanged = (event) => {
    setVehicleType(event.target.value);
    localStorage.setItem("DashboardVehicleTypes", JSON.stringify(event.target.value));
  };
  const jobChanged = (event) => {
    setJob(event.target.value);
    localStorage.setItem("DashboardJobs", JSON.stringify(event.target.value));
  };
  const customerChanged = (event) => {
    setCustomer(event.target.value);
    localStorage.setItem("DashboardCustomers", JSON.stringify(event.target.value));
  };
  const sourceChanged = (event) => {
    setSource(event.target.value);
    localStorage.setItem("DashboardSources", JSON.stringify(event.target.value));
  };
  const destinationChanged = (event) => {
    setDestination(event.target.value);
    localStorage.setItem("DashboardDestinations", JSON.stringify(event.target.value));
  };
  const siteChanged = (event) => {
    setSite(event.target.value);
    localStorage.setItem("DashboardSites", JSON.stringify(event.target.value));
  };
  const productChanged = (event) => {
    setProduct(event.target.value);
    localStorage.setItem("DashboardProducts", JSON.stringify(event.target.value));
  };
  const directionChanged = (event) => {
    setDirection(event.target.value);
    localStorage.setItem("DashboardDirections", JSON.stringify(event.target.value));
  };


    const UpdateData = (lt, src, dest, st, jb, cust, prod, vt, dir) => {
    var params = {
      FromDate: dr.start === null ? "2000-01-01T00:00:00Z" : dr.start.toISOString(),
      ToDate: dr.end === null ? "2050-01-01T00:00:00Z" : dr.end.toISOString(),
      LoadType: GetParamList(lt),
      Source: GetParamIdList(src),
      Destination: GetParamIdList(dest),
      Site: GetParamIdList(st),
      Job: GetParamIdList(jb),
      Customer: GetParamIdList(cust),
      Product: GetParamIdList(prod),
      VehicleType: GetParamIdList(vt),
      Direction: GetParamList(dir)
      };
    

      GetCloudLogin((cred) => {
          let token = cred === "" ? cred : cred.token;
          let sess = GetSession();
          let baseUrl = (token !== undefined && token !== "" ? sess.CloudURL : configData.SERVER_URL);
          const timeOffset = new Date().getTimezoneOffset() / 60;
          baseUrl += `apiV7/dashboard/getperformancetrends?prm=${encodeURI(JSON.stringify(params))}&offset=${timeOffset}&siteId=${sess.SiteID}`;

          const init = {
              method: "GET",
              accept: "application/json",
              headers: { "Authorization": "Bearer " + ((token === null || token === "") ? GetToken() : token) },
          };
          fetch(baseUrl, init)
              .then((response) => response.json())
              .then((d) => {
                  setSales(d.sales);
                  setProductPerformance(d.productPerformance);
                  setAccumulated(d.accumulated);
                  setPieData(d.pieData);
                  setCategories(d.productNames);
                  setLabels(d.labels);
                  if (d.sites === 1) setSiteHeading("Product Share");
                  setTitle(d.title);
                  setSalesYAxis(d.salesY);
                  setProductYAxis(d.productY);
                  setAccYAxis(d.accY);
              });
      })
  }

  const GetParamList = (v) => {
    let r = "";
    if (v === null || v === undefined || v === "") return "";
    v.map(function(val, ind){
      if (r !== "") r += ",";
      r += val;
      return r;
    })
    return r;
  }

  const GetParamIdList = (v) => {
    let r = "";
    if (v === null || v === undefined || v === "") return "";
    v.map(function(val, ind){
      if (r !== "") r += ",";
      r += val.id;
      return r;
    })
    return r;
  }

  const DoSearch = () => {
      UpdateData(loadType, source, destination, site, job, customer, product, vehicleType, direction);
  };

  const ClearSearch = () => {
    setCustomer([]);
    setDateRange([]);
    setDestination([]);
    setDirection([]);
    setJob([]);
    setLoadType([]);
    setProduct([]);
    setSite([]);
    setSource([]);
    setVehicleType([]);
    localStorage.setItem("DashboardDates", null);
    localStorage.setItem("DashboardLoadTypes", null);
    localStorage.setItem("DashboardVehicleTypes", null);
    localStorage.setItem("DashboardJobs", null);
    localStorage.setItem("DashboardCustomers", null);
    localStorage.setItem("DashboardSources", null);
    localStorage.setItem("DashboardDestinations", null);
    localStorage.setItem("DashboardSites", null);
    localStorage.setItem("DashboardProducts", null);
    localStorage.setItem("DashboardDirections", null);
    UpdateData([], [], [], [], [], [], [], [], []);
  };

  React.useEffect(() => {
    UpdateData();
    const baseUrl =
      configData.SERVER_URL + "apiv7/options";
    const init = {
      method: "GET",
      accept: "application/json",
      headers: {"Authorization": "Bearer " + GetToken()},
    };
    fetch(baseUrl, init)
      .then((response) => response.json())
      .then((d) => {
        let lt = []; // filter first in transaction
        for(let i = 0; i < d.loadTypes.length; i++){
            if (d.loadTypes[i] !== "First") lt.push(d.loadTypes[i]);
        }
          setLoadTypes(lt);
          setloadTypeData(lt);
          setVehicleTypes(d.vehicles);
          setvehicleData(d.vehicles);
          setJobs(d.jobs);
          setjobData(d.jobs);
          setCustomers(d.customers);
          setcustomerData(d.customers);
          setSources(d.sources);
          setsourceData(d.sources);
          setDestinations(d.destinations);
          setdestinationData(d.destinations);
          setSites(d.sites);
          setsiteData(d.sites);
          setProducts(d.products);
          setproductData(d.products);
          setDirections(d.directions);
      });
  },[]);

    const filterSiteChange = (event) => { setsiteData(filterBy(sites.slice(), event.filter)); };
    const filterJobChange = (event) => { setjobData(filterBy(jobs.slice(), event.filter)); };
    const filterCustomerChange = (event) => { setcustomerData(filterBy(customers.slice(), event.filter)); };
    const filterSourceChange = (event) => { setsourceData(filterBy(sources.slice(), event.filter)); };
    const filterDestinationChange = (event) => { setdestinationData(filterBy(destinations.slice(), event.filter)); };
    const filterProductChange = (event) => { setproductData(filterBy(products.slice(), event.filter)); };
    const filterLoadTypeChange = (event) => { setloadTypeData(filterBy(loadTypes.slice(), event.filter)); };
    const filterVehicleChange = (event) => { setvehicleData(filterBy(vehicleTypes.slice(), event.filter)); };

  return (
    <>
      <div>
        <Splitter panes={panes} onChange={onChange}>
          <div style={{overflow: "hidden"}}>
            <div className="row"><h6>Filter</h6></div>
            <div className="row">
              <div className="col-md-10" style={{padding: "5px 20px"}}>
                <DateRangePicker id="DateRange" value={dateRange} format="dd/MM/yyyy" onChange={rangeChanged}  />              
              </div>
            </div>
            <div className="row">
            <div className="col-md-10" style={{padding: "5px 20px"}}>
                <label className="control-label">Site</label>
                <MultiSelect id="Site" onFilterChange={filterSiteChange} filterable={true} data={sitedata} value={site} textField="name" dataItemKey="id" onChange={siteChanged} />
              </div>
            </div>
            <div className="row">
            <div className="col-md-10" style={{padding: "5px 20px"}}>
                <label className="control-label">Job</label>
                <MultiSelect id="Job" onFilterChange={filterJobChange} filterable={true} data={jobdata} value={job} textField="name" dataItemKey="id" onChange={jobChanged} />
              </div>
            </div>
            <div className="row">
            <div className="col-md-10" style={{padding: "5px 20px"}}>
                <label className="control-label">Customer</label>
                <MultiSelect id="Customer" onFilterChange={filterCustomerChange} filterable={true} data={customerdata} value={customer} textField="name" dataItemKey="id" onChange={customerChanged} />
              </div>
            </div>
            <div className="row">
            <div className="col-md-10" style={{padding: "5px 20px"}}>
                <label className="control-label">Source</label>
                <MultiSelect id="Source" onFilterChange={filterSourceChange} filterable={true} data={sourcedata} value={source} textField="name" dataItemKey="id" onChange={sourceChanged} />
              </div>
            </div>
            <div className="row">
            <div className="col-md-10" style={{padding: "5px 20px"}}>
                <label className="control-label">Destination</label>
                <MultiSelect id="Destination" onFilterChange={filterDestinationChange} filterable={true} data={destinationdata} value={destination} textField="name" dataItemKey="id" onChange={destinationChanged} />
              </div>
            </div>
            <div className="row">
            <div className="col-md-10" style={{padding: "5px 20px"}}>
                <label className="control-label">Product</label>
                <MultiSelect id="Product" onFilterChange={filterProductChange} filterable={true} data={productdata} value={product} textField="name" dataItemKey="id" onChange={productChanged} />
              </div>
            </div>
            <div className="row">
            <div className="col-md-10" style={{padding: "5px 20px"}}>
                <label className="control-label">Load Type</label>
                <MultiSelect id="LoadType" onFilterChange={filterLoadTypeChange} filterable={true} data={loadTypeData} value={loadType} onChange={loadTypeChanged}/>
              </div>
            </div>
            <div className="row">
            <div className="col-md-10" style={{padding: "5px 20px"}}>
                <label className="control-label">Vehicle Type</label>
                <MultiSelect id="VehicleType" onFilterChange={filterVehicleChange} filterable={true} data={vehicledata} value={vehicleType} textField="name" dataItemKey="id" onChange={vehicleTypeChanged} />
              </div>
            </div>
            <div className="row">
            <div className="col-md-10" style={{padding: "5px 20px"}}>
                <label className="control-label">Direction</label>
                <MultiSelect id="Direction" data={directions} value={direction} onChange={directionChanged}/>
              </div>
            </div>
            <div className="row">
              <div className="col-md-10" style={{padding: "5px 20px"}}>
                <Button onClick={DoSearch} themeColor={"primary"}>Search</Button>{" "}
                <Button onClick={ClearSearch} themeColor={"primary"}>Clear</Button>
              </div>
            </div>
             </div>
             <div className="row" style={{overflow: "hidden"}}>
              {sales && <div className="col-6">
                <button name="sales" className="k-button" onClick={onImageExportClick}>Export as PDF</button>
                <div className="k-card">
                  <Chart ref={sale}  style={{height: 350,}}>
                    <ChartTitle text={title} font="22Pt bold" color="#00008B"/>
                    <ChartLegend position="top" orientation="horizontal" />
                    <ChartCategoryAxis>
                      <ChartCategoryAxisItem categories={labels} startAngle={45}/>
                    </ChartCategoryAxis>
                    <ChartValueAxis>
                        <ChartValueAxisItem title={{ text: salesYAxis }} />
                    </ChartValueAxis>
                    <ChartSeries>
                      {sales.map((item, idx) => (
                        <ChartSeriesItem key={idx} type="line" tooltip={{visible: true }} data={item.data} name={item.name}/>
                      ))}
                    </ChartSeries>
                  </Chart>
                </div>
              </div>}
              {productPerformance && <div className="col-6">
                <button name="product" className="k-button" onClick={onImageExportClick}>Export as PDF</button>
                <div className="k-card">
                  <Chart ref={productgraph}  style={{height: 350}}>
                    <ChartTitle text="Product Performance (Top 5)" font="22Pt bold" color="#00008B" />
                    <ChartLegend position="top" orientation="horizontal" />
                    <ChartCategoryAxis>
                      <ChartCategoryAxisItem categories={categories} startAngle={45} />
                    </ChartCategoryAxis>
                    <ChartValueAxis>
                        <ChartValueAxisItem title={{ text: productYAxis }} />
                    </ChartValueAxis>
                    <ChartSeries>
                      {productPerformance.map((item, idx) => (
                        <ChartSeriesItem key={idx} type="column" tooltip={{visible: true}} data={item.data} name={item.name} />
                      ))}
                    </ChartSeries>
                  </Chart>
                </div>
              </div>}
              {accumulated && <div className="col-6">
                <button name="total" className="k-button" onClick={onImageExportClick}>Export as PDF</button>
                <div className="k-card">
                  <Chart ref={total}  style={{ height: 350 }}>
                    <ChartTitle text="Accumulated Total" font="22Pt bold" color="#00008B" />
                    <ChartLegend position="top" orientation="horizontal" />
                    <ChartCategoryAxis>
                      <ChartCategoryAxisItem categories={labels} startAngle={45} />
                    </ChartCategoryAxis>
                    <ChartValueAxis>
                        <ChartValueAxisItem title={{ text: accYAxis }} />
                    </ChartValueAxis>
                    <ChartSeries>
                      {accumulated.map((item, idx) => (
                        <ChartSeriesItem key={idx} type="area" tooltip={{ visible: true }} data={item.data} name={item.name} />
                      ))}
                    </ChartSeries>
                  </Chart>
                </div>
              </div>}
              {pieData && <div className="col-6">
                <button name="site" className="k-button" onClick={onImageExportClick}>Export as PDF</button>
                <div className="k-card">
                  <Chart ref={sitegraph}  style={{height: 350}}>
                    <ChartTitle text={siteHeading} font="22Pt bold" color="#00008B" />
                    <ChartLegend position="top" orientation="horizontal" />
                    <ChartSeries>
                      <ChartSeriesItem type="pie" overlay={{ gradient: "sharpBevel"}} tooltip={{ visible: true}} data={pieData} categoryField="name" field="share"/>
                    </ChartSeries>
                  </Chart>
                </div>
              </div>}
            </div>
        </Splitter>
      </div>
    </>
  );
};
export default PerformanceTrend;
